module.exports = __webpack_public_path__ + "static/media/2-Clubs.2665b375.svg";